import React, { useEffect, useState } from "react";
import { ShieldAlert, Play } from "lucide-react";
import api, { formatErr } from "../lib/api";

/** QraTab — runs Quantitative Risk Analysis and renders the F-N curve SVG. */
export default function QraTab({ projectId }) {
  const [data, setData] = useState(null);
  const [err, setErr] = useState("");
  const [running, setRunning] = useState(false);

  useEffect(() => {
    let alive = true;
    api.get(`/projects/${projectId}/qra`).then((r) => {
      if (alive) setData(r.data);
    }).catch((e) => alive && setErr(formatErr(e.response?.data?.detail) || e.message));
    return () => { alive = false; };
  }, [projectId]);

  const run = async () => {
    setRunning(true); setErr("");
    try {
      const { data: d } = await api.post(`/projects/${projectId}/qra`, {});
      setData(d);
    } catch (e) { setErr(formatErr(e.response?.data?.detail) || e.message); }
    finally { setRunning(false); }
  };

  if (err) return <div className="pf-sev pf-sev-error" style={{ display: "block", padding: 12 }}>{err}</div>;

  return (
    <div data-testid="qra-tab" style={{ padding: 24 }}>
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 18 }}>
        <div>
          <div className="pf-overline">QUANTITATIVE RISK ANALYSIS</div>
          <div className="pf-heading" style={{ fontSize: 22, margin: "4px 0 0", display: "flex", alignItems: "center", gap: 10 }}>
            <ShieldAlert size={24} color="var(--pf-spark)" /> F-N Curve · ALARP Envelope
          </div>
          <div style={{ fontSize: 12, color: "var(--pf-text-muted)", marginTop: 4 }}>HSE R2P2 / DNV RP-G110 — auto-derived from your simulation inventory</div>
        </div>
        <button type="button" className="btn btn-primary" onClick={run} disabled={running} data-testid="qra-run">
          <Play size={13} /> {running ? "Running…" : "Run / Re-run QRA"}
        </button>
      </div>

      {!data || !data.svg ? (
        <div style={{ padding: 32, textAlign: "center", color: "var(--pf-text-muted)" }}>
          {data === null ? "Loading…" : "No QRA yet — click Run."}
        </div>
      ) : (
        <>
          <div className="pf-card" style={{ padding: 14, marginBottom: 14 }}>
            <div className="pf-overline">VERDICT</div>
            <div data-testid="qra-verdict" style={{ fontSize: 16, fontWeight: 700, marginTop: 4,
              color: (data.fn_curve?.classification || "").includes("INTOL") ? "var(--pf-err)"
                    : (data.fn_curve?.classification || "").includes("ACCEPT") ? "var(--pf-ok)"
                    : "var(--pf-spark)" }}>
              {data.fn_curve?.classification || "—"}
            </div>
            <div style={{ fontSize: 11, color: "var(--pf-text-muted)", marginTop: 4 }}>
              {data.fn_curve?.points?.length || 0} scenarios · {data.fn_curve?.code}
            </div>
          </div>
          <div className="pf-card" style={{ padding: 12, background: "#FAF9F6" }}
                dangerouslySetInnerHTML={{ __html: data.svg }} data-testid="qra-svg" />
        </>
      )}
    </div>
  );
}
